import React, { useEffect, useRef, useState } from 'react'
import { ChatMessageResponse, SingleChat } from '../../Api/Chats/models'
import { Form, OverlayTrigger, Row, Tooltip, Dropdown } from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import { getChatMessages } from '../../Api/Chats/Chats'
import './Styles.css'
import { useSocket } from '../../../../hooks/useSocket'
import { useTestToken } from '../../Hooks/useTestToken'

export const LiveChat = ({ chat }: { chat: SingleChat }) => {

    const chatMessagesRef = useRef<HTMLDivElement>(null)
    const { userInfo } = useTestToken()
    const { socket } = useSocket();

    const [inputMessage, setInputMessage] = useState('')
    const [messages, setMessages] = useState<ChatMessageResponse[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [showEmojis, setShowEmojis] = useState(false);

    const emojis = ['😊', '😂', '👍', '❤️', '😎', '🎮', '💰', '✨', '🔥', '👋', '😅', '🙏', '💪', '🎯', '🌟'];

    const rollDownChat = () => {
        if (chatMessagesRef.current) {
            chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight
        }
    }

    const fetchChatMessages = async () => {
        const res = await getChatMessages({ page: 1, chatId: chat.id })
        if (res) {
            setMessages(res?.messages)
            setCurrentPage(res?.currentPage)
            setHasMore(res?.hasMore)
        }
    }

    const fetchMoreChatMessages = async () => {
        const res = await getChatMessages({ page: currentPage + 1, chatId: chat.id })
        if (res) {
            setMessages([...res?.messages, ...messages])
            setCurrentPage(res?.currentPage)
            setHasMore(res?.hasMore)
        }
    }

    const sendMessage = () => {
        const msg = inputMessage.trim()
        if (msg) {
            setInputMessage("");
            if (socket) {
                const payload = {
                    message: msg,
                    ChatId: chat.id,
                    type: 'text',
                    creatorType: 'admin',
                    PlayerId: chat.PlayerId,
                    OwnerId: chat.OwnerId,
                    UserId: userInfo?.id
                }
                socket.emit(`create-message`, payload)
            }
        }
    };

    const insertEmoji = (emoji: string) => {
        setInputMessage(prev => prev + emoji);
    };

    useEffect(() => {
        fetchChatMessages()
        setTimeout(() => {
            rollDownChat()
        }, 100)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chat])

    useEffect(() => {
        if (socket) {
            socket.on(`update-messages-${chat.id}`, (data: { message: ChatMessageResponse }) => {
                if (data.message.ChatId === chat.id && data.message) {
                    setMessages([...messages, data?.message])
                    setTimeout(() => {
                        rollDownChat()
                    }, 300)
                    // if (socket) {
                    //     socket.emit(`seen-chat`, {
                    //         ChatId: chat.id,
                    //         OwnerId: adminInfo?.id,
                    //         role: 'user',
                    //     });
                    // }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket, chat, messages]);

    return (
        <div className="border border-secondary rounded pt-4 h-100 bg-chat">
            <div className="text-center text-primary">
                Chat con {chat?.Player?.platformUser}
            </div>
            <hr />
            <div className="mb-3 p-3" style={{ minHeight: "65vh", maxHeight: "65vh", overflowY: "auto", display: "flex", flexDirection: "column" }} ref={chatMessagesRef}>
                {hasMore && <div className="text-center text-xs text-secondary mb-0 pb-1 mb-1" role="button" onClick={fetchMoreChatMessages}>
                    Cargar más mensajes
                </div>
                }
                {messages?.map((msg, idx) => (
                    <div className="mb-2" style={{ display: "flex", flexDirection: "column" }} key={idx}>
                        {msg.creatorType === 'player' ?
                            (<React.Fragment key={idx}>
                                <div className={`text-start text-break`} style={{ alignSelf: "flex-start" }}>
                                    <div className="bg-secondary-light rounded-3 p-1 px-2" style={{ marginRight: '50px' }}>
                                        {msg.message}
                                    </div>
                                    <div className="text-xs text-start text-secondary">
                                        {new Date(msg.createdAt).toLocaleTimeString()}
                                    </div>
                                </div>
                            </React.Fragment>)
                            :
                            (<React.Fragment key={idx}>
                                <OverlayTrigger
                                    placement={"left"}
                                    overlay={<Tooltip>Enviado por {msg?.User?.name}</Tooltip>}
                                >
                                    <div className={`text-end text-break`} style={{ alignSelf: "flex-end" }}>
                                        <div className="bg-primaryy text-end rounded-3 p-1 px-2" style={{ marginLeft: '50px' }}>
                                            {msg.message}
                                        </div>
                                        <div className="text-xs text-end text-secondary">
                                            {new Date(msg.createdAt).toLocaleTimeString()}
                                        </div>
                                    </div>
                                </OverlayTrigger>

                            </React.Fragment>)
                        }
                    </div>
                ))}
            </div>
            <hr />
            <Row className="mt-3 py-3">
                <Col xs={1}>
                    <Dropdown show={showEmojis} onToggle={(isOpen) => setShowEmojis(isOpen)} className="d-flex justify-content-center" >
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            className="p-2 mm"
                            style={{ minWidth: '40px' }}
                        >
                            😊
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="bg-dark p-2" style={{ maxWidth: '200px' }}>
                            <div className="d-flex flex-wrap gap-2">
                                {emojis.map((emoji, index) => (
                                    <span
                                        key={index}
                                        role="button"
                                        onClick={() => insertEmoji(emoji)}
                                        style={{ fontSize: '20px' }}
                                    >
                                        {emoji}
                                    </span>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col xs={8}>
                    <Form.Control
                        type="text"
                        placeholder="Escribe un mensaje..."
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)}
                        className="text-light py-2"
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                sendMessage();
                            }
                        }}
                    />
                </Col>
                <Col xs={3}>
                    <Button variant="primary" onClick={sendMessage} className="w-100">
                        Enviar
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
